import { LexicalNode, createCommand, LexicalCommand } from 'lexical';
import { TextMatchTransformer } from '@lexical/markdown';
import { Ticket } from '@certhon/models';
import {
  TicketNode,
  $createTicketNode,
} from '@/components/editor/TicketPlugin/TicketNode';

// Re-export store types and hooks for backwards compatibility
export type { TicketStore } from '@/components/editor/TicketPlugin/TicketStore';
export {
  TicketsStore,
  useTicketsStore,
  useCreateTicketStore,
} from '@/components/editor/TicketPlugin/TicketStore';

export function $isTicketNode(
  node: LexicalNode | null | undefined,
): node is TicketNode {
  return node instanceof TicketNode;
}

export const TICKET_TRANSFORMER: TextMatchTransformer = {
  dependencies: [TicketNode],
  export: (node) => {
    if (!$isTicketNode(node)) {
      return null;
    }
    const ticketId = node.getTicketId();
    const showTitle = node.getShowTitle();
    return `#${ticketId}${showTitle ? '+' : ''}`;
  },
  importRegExp:
    /(?<!&)#([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}|\d+)(\+)?/,
  regExp:
    /#([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}|\d+)(\+)?$/,
  replace: (textNode, match) => {
    const [, ticketId, plus] = match;
    const showTitle = plus === '+';
    const ticketNode = $createTicketNode(ticketId, showTitle);
    textNode.replace(ticketNode);
  },
  trigger: '#',
  type: 'text-match',
};

export const INSERT_TICKET_COMMAND: LexicalCommand<{
  ticket: Ticket;
  showTitle: boolean;
}> = createCommand('INSERT_TICKET_COMMAND');
